import React from 'react';
import { Box, Typography, Link, Divider } from '@mui/material';

const Footer = () => {
  return (
    <Box
      component="footer"
      sx={{
        backgroundColor: '#1a202c',
        color: 'white',
        width: '100%',
        mt: 'auto',
        pt: 3,
        pb: 2,
      }}
    >
      <Divider sx={{ bgcolor: '#2d3748', mb: 2 }} />
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: { xs: 'center', sm: 'center' },
          flexDirection: { xs: 'column', sm: 'row' },
          px: { xs: 2, sm: 8 },
          textAlign: { xs: 'center', sm: 'left' }
        }}
      >
        <Typography variant="body2" sx={{ color: 'gray.300' }}>
          ParseIT
        </Typography>

        <Box>
              <Typography variant="body2" sx={{ color: 'gray.300' }}>
          © {new Date().getFullYear()} ParseIT. Tous droits réservés.
        </Typography>
        {/*}
          <Link href="/privacy" color="inherit" underline="hover" sx={{ mx: 1 }}>
            Politique de confidentialité
          </Link>
          |
          <Link href="/terms" color="inherit" underline="hover" sx={{ mx: 1 }}>
            Conditions d'utilisation
          </Link> */}
        </Box> 
      </Box>
    </Box>
  );
};

export default Footer;
